import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';

function JourneyStatsCoins({ t, icon, value, titleClass }) {
  return (
    <div className="journey-overall-stats-awards-h">
      <div className="journey-overall-stats-awards-item">
        {icon}
        <h6 className={titleClass}>
          {value}
          <span>{t('rewards_coins')}</span>
        </h6>
      </div>
    </div>
  );
}

JourneyStatsCoins.propTypes = {
  t: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  titleClass: PropTypes.string.isRequired,
};

export default translate(JourneyStatsCoins);
